import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SearchSparkle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m22.5 19.5-4.442-4.68M9.412 6.546c1.235-1.273 2.486-1.91 4.53-1.91 3.184 0 5.765 2.66 5.765 5.94s-2.581 5.94-5.765 5.94c-2.299 0-3.961-.884-4.94-2.333m-3.038-8.02a.383.383 0 0 1 .72 0l.99 2.586a.4.4 0 0 0 .218.226l2.51 1.02c.327.132.327.609 0 .741l-2.51 1.02a.4.4 0 0 0-.218.225l-.99 2.587a.383.383 0 0 1-.72 0l-.99-2.586a.4.4 0 0 0-.218-.226l-2.511-1.02c-.327-.132-.327-.609 0-.741l2.51-1.02a.4.4 0 0 0 .219-.225z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SearchSparkle) as SvgIcon;
export { ForwardRef as ReactComponent };
